import { getOKRoofSurfacesExtended } from '@ourbranch/roof-helpers';

export const okRoofSurfacesExtendedHelper = (roofAge, deductibleWindHail, coverageRSExtended) => {
  return getOKRoofSurfacesExtended(roofAge, deductibleWindHail, coverageRSExtended);
};
